import {
  Pagination,
  PaginationGap,
  PaginationList,
  PaginationNext,
  PaginationPage,
  PaginationPrevious,
} from '../catalyst/pagination';
import { Select } from '../catalyst/select';

export default function JFTablePagination(props) {
  const { totalCount, pageSize, page, onPageChange, onRowsPerPageChange, showTotalCount } = props;
  const totalPages = Math.ceil(totalCount / pageSize);

  const pagesLeft = [];
  const pagesRight = [];
  let hasGap = false;
  if (totalPages <= 5) {
    for (let i = 1; i <= totalPages; i++) {
      pagesLeft.push(i);
    }
  }

  if (totalPages > 5) {
    hasGap = true;
    pagesLeft.push(1, 2, 3);
    for (let i = totalPages - 2; i <= totalPages; i++) {
      pagesRight.push(i);
    }
  }

  return (
    <div className="flex justify-center gap-x-4 items-center py-4 bg-zinc-50 sticky bottom-0">
      {showTotalCount && <div className="w-24 font-bold text-black">{totalCount} rows</div>}
      <Pagination className="">
        <PaginationPrevious
          disabled={page === 1}
          onClick={(event) => {
            onPageChange(event, page - 1);
          }}
        />
        <PaginationList>
          {pagesLeft.map((pageNumber) => (
            <PaginationPage
              key={pageNumber}
              onClick={(event) => {
                onPageChange(event, pageNumber);
              }}
              current={page === pageNumber}
            >
              {pageNumber}
            </PaginationPage>
          ))}
          {hasGap && <PaginationGap />}
          {pagesRight.map((pageNumber) => (
            <PaginationPage
              key={pageNumber}
              onClick={(event) => {
                onPageChange(event, pageNumber);
              }}
              current={page === pageNumber}
            >
              {pageNumber}
            </PaginationPage>
          ))}
        </PaginationList>
        <PaginationNext
          disabled={page >= Math.ceil(totalCount / pageSize)}
          onClick={(event) => {
            onPageChange(event, page + 1);
          }}
        />
      </Pagination>
      <div className="w-40">
        <Select
          name="pageSize"
          onChange={onRowsPerPageChange}
          value={pageSize}
        >
          <option value="10">10 per page</option>
          <option value="25">25 per page</option>
          <option value="50">50 per page</option>
          <option value="100">100 per page</option>
        </Select>
      </div>
    </div>
  );
}
